module.exports = __webpack_public_path__ + "media/two_green.eb8184f9.mp3";